export var CarriedInterestDayCountFormat;
(function (CarriedInterestDayCountFormat) {
    CarriedInterestDayCountFormat["ActualActual"] = "ActualActual";
    CarriedInterestDayCountFormat["Actual365"] = "Actual365";
    CarriedInterestDayCountFormat["Actual360"] = "Actual360";
    CarriedInterestDayCountFormat["Fixed30By365"] = "Fixed30by365";
    CarriedInterestDayCountFormat["Fixed30By360"] = "Fixed30by360";
})(CarriedInterestDayCountFormat || (CarriedInterestDayCountFormat = {}));
export var CarriedInterestFeeAllocationMethod;
(function (CarriedInterestFeeAllocationMethod) {
    CarriedInterestFeeAllocationMethod["CommitmentProRata"] = "CommitmentProRata";
    CarriedInterestFeeAllocationMethod["InvestorSpecific"] = "InvestorSpecific";
})(CarriedInterestFeeAllocationMethod || (CarriedInterestFeeAllocationMethod = {}));
export var WaterfallStructure;
(function (WaterfallStructure) {
    WaterfallStructure["ReturnOfCapital"] = "ReturnOfCapital";
    WaterfallStructure["PreferredReturn"] = "PreferredReturn";
    WaterfallStructure["CarriedInterestPartnerCatchup"] = "CarriedInterestPartnerCatchup";
    WaterfallStructure["ExcessProceeds"] = "ExcessProceeds";
})(WaterfallStructure || (WaterfallStructure = {}));
export var PreferredReturnAccrualMethod;
(function (PreferredReturnAccrualMethod) {
    PreferredReturnAccrualMethod["Simple"] = "Simple";
    PreferredReturnAccrualMethod["Compound"] = "Compound";
})(PreferredReturnAccrualMethod || (PreferredReturnAccrualMethod = {}));
export var PreferredReturnAccrualPeriod;
(function (PreferredReturnAccrualPeriod) {
    PreferredReturnAccrualPeriod["Daily"] = "Daily";
    PreferredReturnAccrualPeriod["Monthly"] = "Monthly";
    PreferredReturnAccrualPeriod["Quarterly"] = "Quarterly";
})(PreferredReturnAccrualPeriod || (PreferredReturnAccrualPeriod = {}));
export var PreferredReturnCompoundingPeriod;
(function (PreferredReturnCompoundingPeriod) {
    PreferredReturnCompoundingPeriod["Daily"] = "Daily";
    PreferredReturnCompoundingPeriod["Monthly"] = "Monthly";
    PreferredReturnCompoundingPeriod["Quarterly"] = "Quarterly";
    PreferredReturnCompoundingPeriod["Yearly"] = "Yearly";
})(PreferredReturnCompoundingPeriod || (PreferredReturnCompoundingPeriod = {}));
export var PreferredReturnCalculationEnd;
(function (PreferredReturnCalculationEnd) {
    PreferredReturnCalculationEnd["UponFullReturnOfCapital"] = "UponFullReturnOfCapital";
    PreferredReturnCalculationEnd["UponFullReturnOfCapitalPlusAccruedPreferredReturn"] = "UponFullReturnOfCapitalPlusAccruedPreferredReturn";
})(PreferredReturnCalculationEnd || (PreferredReturnCalculationEnd = {}));
export var PreferredReturnBasis;
(function (PreferredReturnBasis) {
    PreferredReturnBasis["Drawn"] = "Drawn";
})(PreferredReturnBasis || (PreferredReturnBasis = {}));
export var CapitalContributionType;
(function (CapitalContributionType) {
    CapitalContributionType["FixedAmount"] = "FixedAmount";
    CapitalContributionType["PercentageOfTotalCapital"] = "PercentageOfTotalCapital";
})(CapitalContributionType || (CapitalContributionType = {}));
//# sourceMappingURL=index.js.map